export default __webpack_public_path__ + "static/media/Broadcasting.b7305587.png";